"use client"
import SEO from "../../../data/seo";
import FooterTwo from "../../../layout/footers/footer-two";
import HeaderTwo from "../../../layout/headers/header-two";
import AboutTwo from "./about";
import BannerTwo from "./banner";
import BlogTwo from "./blog";
import AboutMain from "../../about/about";
import FaqArea from "./faq";
import PortfolioTwo from "./portfolio";
import Portfolio from "../home/portfolio";
import ServicesTwo from "./services";
import TestimonialTwo from "./testimonial";

const HomeTwo = () => {
    return (
        <>
            <SEO pageTitle="Home"
                keywords={[
                    "engineersbay",
                    "Civil engineering consulting",
                    "engineers day",
                    "engineers",
                    "civil engineers",
                    "Construction company in Bangladesh",
                    "Best construction company in Dhaka",
                    "The Engineersbay Limited projects",
                    "MEP engineering services",
                    "Feasibility study for construction projects",
                    "Top real estate developers in Bangladesh",
                    "Engineering firm in Gulshan",
                    "civil Engineering",
                    "Construction Supply"
                ]} />
            <HeaderTwo />
            {/* Accessible, single H1 for the page (visually hidden) */}
            <h1 style={{ position: 'absolute', width: '1px', height: '1px', padding: 0, margin: '-1px', overflow: 'hidden', clip: 'rect(0, 0, 0, 0)', whiteSpace: 'nowrap', border: 0 }}>The EngineersBay — Construction & Engineering Services</h1>
            <BannerTwo />
            <ServicesTwo />
            <AboutTwo />
            <AboutMain />
            <Portfolio />
            <FaqArea />
            {/* <TestimonialTwo /> */}
            {/* <BlogTwo /> */}
            <FooterTwo />
        </>
    );
};

export default HomeTwo;